<template>
    <div>
        <Cell border style="margin-bottom: 5px;line-height: 10px">
            <Icon slot="extra" name="delete" style="margin: 4% 6% " color="red" size="20" @click="deleteDanger"/>
            <h3>{{dangerStateDICT}}</h3>
            <p>{{taskDanger.remark}}</p>
            <p>{{taskDanger.createdTime}}</p>
        </Cell>
    </div>
</template>

<script>
    import {Cell,Icon,Dialog} from "vant"
    import * as DICT from "@/utils/dict"


    export default {
        components: {Icon,Cell,Dialog},
        props: {
            taskDanger: {type: Object, required: true}
        },
        data() {
            return {};
        },
        computed: {
            dangerStateDICT() {
                return DICT.getValue('DANGER_TYPE', this.taskDanger.type)
            },
        },
        created() {
        },
        mounted() {

        },
        methods: {
            deleteDanger() {
                Dialog.confirm({
                    message: '确定删除吗',
                }).then(()=>{
                    this.$toast.loading("正在处理中");
                    this.$http.tokiot.prospect.taskDanger.delete({id:this.taskDanger.id})
                        .then(res => {
                            this.$toast.clear();
                            if (res) {
                                this.$toast.success("删除成功");
                               this.$emit("onRefresh")
                            }
                        })
                })
              }
        },
        watch: {}
    };
</script>


